import React, { useState } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import FinalStep from "./FinalStep";

function App() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  const nextStep = (data) => {
    setFormData({ ...formData, ...data });
    setStep(step + 1);
  };

  const previousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return (
    <div className="App">
      <h2>Registration</h2>
      {step === 1 && <Step1 nextStep={nextStep} />}
      {step === 2 && (
        <Step2
          formData={formData}
          nextStep={nextStep}
          previousStep={previousStep}
        />
      )}
      {step === 3 && (
        <FinalStep formData={formData} previousStep={previousStep} />
      )}
      {/* ... other steps */}
      {step > 1 && <button onClick={previousStep}>Back</button>}
    </div>
  );
}

export default App;
